import React, { useEffect, useState, useMemo, use } from "react"
import { motion } from 'framer-motion'
import API from "../../Common/API"
import DatatableLoader from "../../Components/Loaders/DataTableLoader"
import { datatableTheme } from "../../Common/dataTableTheme"
import DataTable, { createTheme } from "react-data-table-component"
import InlineTextField from "../../Components/InLineTextField"
import { useHistory } from "react-router-dom"
import { FaCircleCheck, FaPen, FaPlus } from "react-icons/fa6"
import { RiCloseCircleFill } from "react-icons/ri"
import { useDispatch } from "react-redux"
import { setAlert } from "../../Store/Theme/actions"
import FieldInput from "../../Components/FieldInput"
import * as Yup from 'yup'
import { useFormik } from "formik"
import Dialog from "../../Components/Dialog"
import Button from "../../Components/Button"

createTheme('defaultLight', datatableTheme.default)
createTheme('defaultDark', datatableTheme.dark)

const initialProfession = {
    occupation : '',
    tOccupation : '',
}
const Professions = () => {

    const [planList, setPlanList] = useState([])
    const [loading, setLoading] = useState(true)
    const [filter, setFilter] = useState('')
    const [page, setPage] = useState(0)
    const history = useHistory()
    const dispatch = useDispatch()
    const [count, setCount] = useState(0)
    const [openAddProfession,setOpenAddProfession] = useState(false)
    const [openEditProfession,setOpenEditProfession] = useState(false)

    useEffect(() => {
        setLoading(true)
        try {
            API.get('/common/getAllOccupations').then((planRes) => {
                if (planRes.status === 200) {
                    setPlanList(planRes.data.data)
                    setLoading(false)
                }
            })
        } catch (err) {
            console.log(err)
        }
    }, [count])

    const columns = useMemo(() => [
        { name: 'S.No', selector: (row, i) => i + 1, initialActive: true, sortable: true, width: '100px' },
        { name: 'Profession', selector: row => row.occupation, initialActive: true, sortable: true },
        { name: 'Profession', selector: row => row.tOccupation, sortable: true },
        { name: 'Status', selector: row => row.activeStat === 'A' ? 'Acitve' : 'Deactivated', initialActive: true, sortable: true },
        {
            name: 'Action', selector: row => <motion.div className="relative flex flex-row w-full justify-between">
                {row.activeStat === 'D' && <FaCircleCheck color="green" className="mx-2 cursor-pointer" onClick={() => activatePlans(row)} />}
                {row.activeStat === 'A' && <RiCloseCircleFill color="red" className="mx-2 cursor-pointer" onClick={() => deactivatePlans(row)} />}
                <motion.div className="mx-2 text-[indigo] cursor-pointer" onClick={() => editProfessions(row)}>
                    <FaPen title="Category edit" />
                </motion.div>
            </motion.div>, initialActive: true, sortable: true
        }
    ], [])
    const filteredcasedetails = useMemo(() => {
        const filterSplit = filter.toLowerCase().split(' ')
        return planList.filter(c =>
            filterSplit.every(i =>
                Object.keys(c).some(j => c[j]?.toString().toLowerCase().includes(i))
            )
        )
    }, [planList, filter])

    const SubHeader = useMemo(() => (
        <div className="flex flex-row items-center">
            <InlineTextField label={"Search"} value={filter} setValue={setFilter} />
            <motion.div className="h-9 mx-2 w-9 rounded-full bg-white flex flex-col items-center cursor-pointer justify-center" onClick={() => setOpenAddProfession(true)}><FaPlus /></motion.div>
        </div>
    ), [filter])// eslint-disable-line

    const activatePlans = (values) => {
        API.post('/common/activateProfession', values).then((apiRes) => {
            if (apiRes.status === 200) {
                dispatch(setAlert({ title: "Success", subtitle: "Profession Activated successfully", active: true, type: 'success' }))
                setCount(count + 1)
            }
        })
    }

    const deactivatePlans = (values) => {
        API.post('/common/deactivateProfession', values).then((apiRes) => {
            if (apiRes.status === 200) {
                dispatch(setAlert({ title: "Success", subtitle: "Profession Deactivated successfully", active: true, type: 'success' }))
                setCount(count + 1)
            }
        })
    }

    const professionSchema = Yup.object().shape({
        occupation: Yup.string().required('Profession is required'),
        tOccupation: Yup.string().required('Translated Profession is required'),
    })

    const professionForm = useFormik({
        initialValues : initialProfession,
        validateOnMount : true,
        validationSchema : professionSchema,
        enableReinitialize : true,
        onSubmit:(values)=>{
            API.post('/common/insertOccupation',values).then((res)=>{
                if(res.status === 200){
                    dispatch(setAlert({ title: 'Success', subtitle: 'Profession Created Successfully', active: true, type: 'success' }))
                    setOpenAddProfession(false)
                    setCount(count + 1)
                }
            })
        }
    })

    const translateValues = (value, key, actualValue) => {
        professionForm.setValues({ ...professionForm.values, occupation: actualValue, tOccupation: value })
    }

    const editProfessions = (values)=>{
        professionForm.setValues({...professionForm.values,...values})
        setOpenEditProfession(true)
    }

    const editProfession = ()=>{
        try{
            API.post('/common/editOccupation',professionForm.values).then((res)=>{
                if(res.status === 200){
                    dispatch(setAlert({ title: 'Success', subtitle: 'Profession Updated Successfully', active: true, type: 'success' }))
                    setOpenEditProfession(false)
                    setCount(count + 1)
                }
            })
        }catch(err){
            console.log(err)
        }
    }

    return (
        <motion.div>
            {loading ? (
                <DatatableLoader />
            ) : (
                <motion.div className="h-full w-full bg-opacity-10 drop-shadow-lg">
                    <DataTable
                        title="Plan List"
                        theme="defaultLight"
                        columns={columns}
                        data={filteredcasedetails}
                        pagination
                        highlightOnHover
                        selectableRowsHighlight
                        persistTableHead
                        subHeader
                        subHeaderComponent={SubHeader}
                        noDataComponent={'There are no records to display'}
                    />
                </motion.div>
            )}
            {/* <Dialog injectClass={'min-w-screen'} showDialog={openEditModal} title={'Edit User'} onClose={() => setOpenEditModal(false)}>
                <PreviewUser registerValues={userId} onClose={() => setOpenEditModal(false)} />
            </Dialog> */}
            {/* <Dialog injectClass="w-350px" showDialog={openDeleteModal} title={'Deactivate User'} onClose={() => setOpenDeleteModal(false)}>
                <motion.div className="w-full flex flex-col">
                    Are you sure you want to deactivate this user.
                    <motion.div className="w-full flex flex-row justify-between">
                        <Button injectClass={'bg-[red]/90 text-white rounded-full cursor-pointer'} onClick={() => setOpenDeleteModal(false)}>No</Button>
                        <Button injectClass={'bg-[green] text-white rounded-full cursor-pointer'} onClick={() => deleteUser()}>Yes</Button>
                    </motion.div>
                </motion.div>
            </Dialog>
            <Dialog injectClass="w-350px" showDialog={openActiveModal} title={'Activate User'} onClose={() => setOpenActiveModal(false)}>
                <motion.div className="w-full flex flex-col">
                    Are you sure you want to activate this user.
                    <motion.div className="w-full flex flex-row justify-between">
                        <Button injectClass={'bg-[red]/90 text-white rounded-full cursor-pointer'} onClick={() => setOpenActiveModal(false)}>No</Button>
                        <Button injectClass={'bg-[green] text-white rounded-full cursor-pointer'} onClick={() => reactiveUser()}>Yes</Button>
                    </motion.div>
                </motion.div>
            </Dialog> */}
             <Dialog injectClass="w-350px" showDialog={openAddProfession} title={'Add Profession'} onClose={() => setOpenAddProfession(false)}>
                <motion.div className="w-full flex flex-col">
                    <motion.div className="grid grid-cols-2 my-2 w-full">
                        <FieldInput translate={true} label={'Profession'} outerInjectClass={'w-full'} fieldProps={professionForm.getFieldProps('occupation')} fieldMeta={professionForm.getFieldMeta('occupation')} fieldHelper={professionForm.getFieldHelpers('occupation')} edit={true} dataLoaded={true} onChange={(ev)=>translateValues(ev.translatedValue,'occupation',ev.value)}/>
                        <FieldInput label={'Tamil Profession'} outerInjectClass={'w-full'} fieldProps={professionForm.getFieldProps('tOccupation')} fieldMeta={professionForm.getFieldMeta('tOccupation')} fieldHelper={professionForm.getFieldHelpers('tOccupation')} edit={true} dataLoaded={true} />
                    </motion.div>
                    <motion.div className="w-full flex flex-row justify-between">
                        <Button injectClass={'bg-[red]/90 text-white rounded-full cursor-pointer'} onClick={() => setOpenAddProfession(false)}>Cancel</Button>
                        <Button injectClass={'bg-[green] text-white rounded-full cursor-pointer'} onClick={() => professionForm.submitForm()}>Create</Button>
                    </motion.div>
                </motion.div>
            </Dialog>
             <Dialog injectClass="w-350px" showDialog={openEditProfession} title={'Edit Profession'} onClose={() => setOpenEditProfession(false)}>
                <motion.div className="w-full flex flex-col">
                    <motion.div className="grid grid-cols-2 my-2 w-full">
                        <FieldInput translate={true} label={'Profession'} outerInjectClass={'w-full'} fieldProps={professionForm.getFieldProps('occupation')} fieldMeta={professionForm.getFieldMeta('occupation')} fieldHelper={professionForm.getFieldHelpers('occupation')} edit={true} dataLoaded={true} onChange={(ev)=>translateValues(ev.translatedValue,'occupation',ev.value)}/>
                        <FieldInput label={'Tamil Profession'} outerInjectClass={'w-full'} fieldProps={professionForm.getFieldProps('tOccupation')} fieldMeta={professionForm.getFieldMeta('tOccupation')} fieldHelper={professionForm.getFieldHelpers('tOccupation')} edit={true} dataLoaded={true} />
                    </motion.div>
                    <motion.div className="w-full flex flex-row justify-between">
                        <Button injectClass={'bg-[red]/90 text-white rounded-full cursor-pointer'} onClick={() => setOpenEditProfession(false)}>Cancel</Button>
                        <Button injectClass={'bg-[green] text-white rounded-full cursor-pointer'} onClick={() => editProfession()}>Update</Button>
                    </motion.div>
                </motion.div>
            </Dialog>
        </motion.div>
    )
}

export default Professions